<template>
  <div class="modal-drag-custom-drag" :class="$vuetify.breakpoint.mobile && 'mobile-popup'" :style="{ zIndex: indexModalIndex }">
		<modal
			name="custom_drag_modal"
			:style="{ zIndex: indexModalIndex }"
			hide-overlay
			draggable=".drag-header"
			:clickToClose="true"
			@before-close="closeModal"
			:focusTrap="true"
			:adaptive="true"
			height="auto"
			ref="modal"
		>
      <v-card>
        <v-card-title class="pa-0 drag-header">
					<div class="d-flex flex-row align-center justify-space-between py-2 px-8 w-100">
						<div class="d-flex flex-row align-center">
							<v-icon color="white" class="info-icon mr-2">mdi-list-box-outline</v-icon>
							<div>
								<p class="mb-0 font-weight-bold text-primary title">Proyecto</p>
							</div>
						</div>
						<v-btn class="mx-2" fab dark small color="#FF1209" @click="closeModal">
							<v-icon dark>mdi-close</v-icon>
						</v-btn>
					</div>
				</v-card-title>
        <v-card-text class="pa-0">
          <div class="py-4 px-8">
            <v-form ref="form" v-model="validform" class="mt-6">
              <v-row class="mb-4">
								<v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="newCostBreakdownBaseProject.name"
                    label="Proyecto"
                    placeholder="Ingrese el nombre del proyecto"
                    outlined
                    required
                    dense
                    :rules="requiredRule"
                  ></v-text-field>
									<p class="mb-0 font-weight-bold caption">Por favor indica si este proyecto se trata de un proyecto de arquitectura</p>
									<p class="mb-0" style="font-size: 10px;">Al seleccionar esta opción en la tabla de costo aparecerán las etapas que considera un proyecto de arquitectura, como por ejemplo <b>Recepción Final</b></p>
									<div class="d-flex align-center mt-1" style="width: 100%">
										<v-checkbox class="my-0 py-0" v-model="newCostBreakdownBaseProject.is_architectural" color="#959595" hide-details dense></v-checkbox>
										<p class="mb-0 caption font-weight-bold">Es un Proyecto de Arquitectura</p>
									</div>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="12">
                  <div class="d-flex flex-row justify-end">
                    <v-btn
                      class="mx-2 my-1"
                      color="white"
                      raised
                      @click="closeModal"
                    >
                      <p class="mb-0 text-primary">Cancelar</p>
                    </v-btn>
                    <v-btn
                      class="mx-2 my-1"
                      color="#524D4D"
                      raised
                      dark
                      :loading="loadingData"
                      @click="sendForm"
                    >
                      <p class="mb-0">Confirmar</p>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </div>
        </v-card-text>
      </v-card>
    </modal>
  </div>
</template>

<script>
import {createCostBaseProject, updateCostBaseProject} from '@/helpers/api/costs'

export default {
  name: 'CostBreakdownBaseProjectModal',
  components: { },
  data: () => ({
		indexModal: + new Date(),
    validform: true,
		loadingData: false,
    newCostBreakdownBaseProject: {
			company_base_project_id: null,
			is_architectural: false,
			name: null
    },
    requiredRule: [
      v => !!v || 'Campo requerido'
    ]
  }),
  computed: {
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		}
  },
  mounted(){
		if(this.$store.state.costbreakdown.newCostBreakdownBaseProjectModalEditing){
			this.newCostBreakdownBaseProject = this.$store.state.costbreakdown.newCostBreakdownBaseProjectModalEditing
		}
		this.$modal.show('custom_drag_modal')
		this.$store.commit('general/addOpenModalOrders', this.indexModal)
		this.$store.dispatch('costbreakdown/getCompanyBaseProjects')
  },
  methods: {
    closeModal(){
      this.$store.commit('costbreakdown/setNewCostBreakdownBaseProjectModal', false)
			this.$store.commit('costbreakdown/setNewCostBreakdownBaseProjectModalEditing', null)
      this.newCostBreakdownBaseProject = {
				company_base_project_id: null,
				is_architectural: false,
				name: null
			}
      this.validform = true
      this.loadingData = false
    },
    async sendForm(){
      if(this.$refs.form.validate()){
				this.loadingData = true
        const company = this.newCostBreakdownBaseProject.company_base_project_id ? await updateCostBaseProject(this.newCostBreakdownBaseProject):await createCostBaseProject(this.newCostBreakdownBaseProject)
        if(company.code === 200){
          const messageData = {
            message: this.newCostBreakdownBaseProject.company_base_project_id ? 'El proyecto ha sido actualizado':'Se ha creado correctamente el proyecto',
            title: this.newCostBreakdownBaseProject.company_base_project_id ? 'Proyecto Actualizado':'Proyecto creado',
            type: 'success',
            icon: 'mdi-check-circle',
            color: '#3EBFA3',
          }
					this.$store.dispatch('costbreakdown/getCompanyBaseProjects')
          this.setMessage(messageData)
          this.closeModal()
        }
        else{
          const messageData = {
            message: 'Hubo un error en la operación, por favor intenta nuevamente',
            title: 'Ha ocurrido un error',
						type: 'danger',
						icon: 'mdi-close-octagon',
						color: '#FF1209',
          }
          this.setMessage(messageData)
        }
				this.loadingData = false
      }
    },
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
  }
};
</script>

<style scoped>
	.profile-avatar{
		cursor: pointer;
	}
  .info-container{
    color: #606060;
  }
  .text-primary{
    color: #524D4D;
  }
  .info-icon{
    background-color: #524D4D;
    border-radius: 25px;
    padding: 3px;
    width: 35px;
    height: 35px;
  }
  .info-icon.small-icon{
    width: 25px;
    height: 25px;
  }
  .info-img{
    width: 100%;
    max-height: 50px;
    object-fit: contain;
  }
  .adjuntos-container{
    background-color: #EFEFEF;
    max-height: 95px;
    overflow-y: scroll;
  }
  .interaction-container{
    width: 100%;
    background-color: #E5E9F2;
    border-radius: 5px;
    position: relative;
    padding: 12px;
  }
  .user-avatar.small{
    width: 25px;
    height: 25px;
  }
  .light-blue-text{color: #959595;}
  .interaction-container .icon-arrow{
    font-size: 80px;
    position: absolute;
    top: 20px;
    line-height: inherit;
  }
  .interaction-container.right .icon-arrow{
    left: -46px;
  }
  .interaction-container.left .icon-arrow{
    right: -46px;
  }
  /deep/ .custom-input-numbers .v-input__slot{padding:0!important;}
  /deep/ .custom-input-numbers .v-input__prepend-inner,
  /deep/ .custom-input-numbers .v-input__append-inner,
  /deep/ .custom-text-input .v-input__append-inner{margin-top:0!important;}
  /deep/ .custom-input-numbers input {text-align: center }
</style>